import React, { useState } from "react";
import { BooleanField, classnames } from "@culturehq/components";

import { t, Trans } from "app/utils";
import { makePatch } from "@culturehq/client";
import { useProfile } from "app/context";
import ChqModalConfirm from "components/common/ChqModalConfirm";

const ApproveForLandingPageButton = ({
  approvedContent, externalState, onUpdateApprovedForSocial
}) => {
  const { profile, fetchedProfile } = useProfile();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const cmkMarked = state => externalState === state || externalState === "approved_for_everything";

  const onApproveLandingPageClicked = async () => {
    let state = "";
    switch (externalState) {
      case "approved":
        state = "landing_page";
        break;
      case "social":
        state = "approved_for_everything";
        break;
      case "approved_for_everything":
        state = "social";
        break;
      case "landing_page":
        state = "approved";
        break;
      default:
        state = "approved";
        break;
    }

    if (doNotShowAgain) {
      const body = {};
      if (cmkMarked("landing_page")) {
        body.showLandingPageDelete = false;
      } else {
        body.showLandingPageCreate = false;
      }
      const { user } = await makePatch("/admin/admin_user_configuration", body);
      fetchedProfile(user);
    }

    const { approvedForSocial } = await makePatch(`/stories/approved/${approvedContent.id}`, { externalState: state });
    onUpdateApprovedForSocial(approvedForSocial);
  };

  if ((!cmkMarked("landing_page") && !profile?.adminUserConfiguration?.showLandingPageCreate)
    || (cmkMarked("landing_page") && !profile?.adminUserConfiguration?.showLandingPageDelete)) {
    return (
      <BooleanField
        onChange={value => {
          if (value === cmkMarked("landing_page")) {
            return;
          }
          onApproveLandingPageClicked();
        }}
        className={classnames("LandingPage-cmk", { "LandingPage-cmk-marked": cmkMarked("landing_page") })}
        value={cmkMarked("landing_page")}
      >
        <Trans>Culture Page</Trans>
      </BooleanField>
    );
  }

  return (
    <ChqModalConfirm
      accept={t("Confirm")}
      onAccept={onApproveLandingPageClicked}
      trigger={onTrigger => (
        <BooleanField
          onChange={value => {
            if (value === cmkMarked("landing_page")) {
              return;
            }
            onTrigger();
          }}
          className={classnames("LandingPage-cmk", { "LandingPage-cmk-marked": cmkMarked("landing_page") })}
          value={cmkMarked("landing_page")}
        >
          <Trans>Culture Page</Trans>
        </BooleanField>
      )}
      disclaimer={(
        <BooleanField
          className="Confirm__legend"
          onChange={value => setDoNotShowAgain(value)}
          value={doNotShowAgain}
        >
          <span>Do not show this again</span>
        </BooleanField>
      )}
    >
      <Trans>
        {cmkMarked("landing_page") ? (
          <>
            You are about to disallow this story to be shared on the Culture Page. If your
            Page is live, this will remove the story.
          </>
        ) : (
          <>
            You are about to allow this story to be shared on the Culture Page. If your
            Page is live, the story will display right away.
          </>
        )}
      </Trans>
    </ChqModalConfirm>
  );
};

export default ApproveForLandingPageButton;
